import {
  PageContainer,
  PageContent,
  PageFooterBar,
} from "../../components/PageContainer";
import _ from "lodash";
import { BreadCrumbs, TitleBar } from "../../components/TitleBar";
import { BackButton, SaveButton } from "../../components/Button";
import { useParams } from "react-router";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import apiAgent from "../../api/apiAgent";
import { getDataAndSchemaFromModel } from "../../components/Forms/utils";
import { useAtomValue } from "jotai";
import { modelDataAtom, useValidateModel } from "../../atoms";
import { tMsg } from "../../components/ToastNotifications";
import { checkTitle, useOriginParams } from "../../utils";
import MediaItemsForm from "./customisation/MediaItemForm";
import { useSetChangesMade } from "../../components/Publishing/utils";

const UpdateMediaItem = ({
  modelName,
}: {
  modelName: "media_item" | "attract_media_item";
}): JSX.Element => {
  const navigate = useNavigate();
  const params = useParams();
  const [originFrom, originId] = useOriginParams();
  const modelData = useAtomValue(modelDataAtom);
  // const modelName = "media_item";
  useValidateModel(modelName);
  const setChangesMade = useSetChangesMade(originFrom || modelName);

  const [itemData, setItemData] = useState<any>(null);
  const [schema, setSchema] = useState<any[]>([]);
  const [isLoadingData, setIsLoadingData] = useState<boolean>(true);
  const [isLoadingSchema, setIsLoadingSchema] = useState<boolean>(true);

  useEffect(() => {
    if (modelData && modelData !== null && isLoadingSchema) {
      const [, getSchema] = getDataAndSchemaFromModel(
        modelData,
        modelName,
        true
      );
      // we don't set item data for update
      setSchema(getSchema);
      setIsLoadingSchema(false);
    }
  }, [modelData]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await apiAgent.DataType.get(modelName, params?.id || -1);
      const item = response.data[0] || null;

      setItemData(item);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoadingData(false);
    }
  };

  const saveItem = async () => {
    try {
      const response = await apiAgent.DataType.update(modelName, {
        bulk_fields: [itemData],
        fields_to_set: Object.keys(itemData).filter((k) => {
          return k !== "id" || itemData[k] !== null;
        }),
        fields_to_match: ["id"],
      });
      if (response.status === 200) {
        tMsg.success(`Successfully updated`);
        setChangesMade();
        if (originFrom && originId)
          navigate(`/m/${originFrom}/show/${originId}`);
        else navigate(`/m/${modelName}`);
      } else throw response.statusText;
    } catch (err) {
      tMsg.error(`Error changing ${modelName}`);
      console.log(err);
    }
  };

  const crumbs =
    originFrom && originId
      ? [
          {
            label: `${checkTitle(originFrom)} - ${originId}`,
            link: `/m/${originFrom}/${originId}`,
          },
        ]
      : [
          {
            label: `${checkTitle(modelName)} - ${itemData.id}`,
            link: `/m/${modelName}/${itemData.id}`,
          },
        ];

  const customModel = `${originFrom}_media`;

  return (
    <PageContainer
      isLoading={isLoadingData || isLoadingSchema}
      className="relative"
    >
      <PageContent reduceHeightForFooter>
        <BreadCrumbs crumbs={crumbs} />
        <TitleBar title={`Edit ${checkTitle(modelName)}`}>
          <BackButton />
        </TitleBar>
        <MediaItemsForm
          modelName={modelName}
          itemData={itemData}
          setItemData={setItemData}
          schema={schema}
          customModel={customModel}
          onSubmit={(e) => {
            e.preventDefault();
            saveItem();
          }}
        />
      </PageContent>
      <PageFooterBar>
        <SaveButton />
      </PageFooterBar>
    </PageContainer>
  );
};

export default UpdateMediaItem;
